import React from "react";
import kcevent1 from "../../../images/kcevent1.jpg";
import kcevent2 from "../../../images/kcevent2.jpg";
import kcevent3 from "../../../images/kcevent3.jpg";
import kcevent4 from "../../../images/kcevent4.jpg";
import kcevent5 from "../../../images/kcevent5.jpg";
import kcevent6 from "../../../images/kcevent6.jpg";
import EngagementCarouselPage from "../../ui/EngagementCarouselPage";

const KCCollege = () => (
  <EngagementCarouselPage
    title="KC College Event"
    paragraphs={[
      "On the 13th of Feb, Kindness Unlimited in association with KC College's intercollegiate festival- Joule, organised a fantastic event that brought together a bunch of less fortunate street children and a set of competing teams from various colleges across the city. The event required both the college students and the children to work together in order to win. These college students didn't simply invite these kids into their teams but into their hearts, a kindness for which there are no words.",
    ]}
    images={[kcevent1, kcevent2, kcevent3, kcevent4, kcevent5, kcevent6]}
  />
);

export default KCCollege;
